module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "dialog-post-upload"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("AI批量岗位生成")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "up-text"
  }, [_vm._v("您可以将公司招聘公告文档上传，AI将会自动识别岗位内容，并根据平台要求智能补充招聘信息，形成批量待发布岗位！目前算力紧张，最多支持5条岗位招聘信息批量生成、发布。")]), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "drag": "",
      "action": (_vm.PRO_URL + "/files/upload"),
      "multiple": false,
      "headers": _vm.headers,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('img', {
    staticClass: "file-logo",
    attrs: {
      "src": require("@/assets/images/icon_file.png")
    }
  }), _vm._v(" "), (!_vm.fileInfo.upload_file_id) ? [_c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("点击上传")]), _vm._v("或将文件拖到此区域")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("上传格式为xls、docx、xlsx、pdf文件，大小在60M以内")])] : _c('div', {
    staticClass: "el-upload-success"
  }, [_c('i', {
    staticClass: "el-icon-upload-success el-icon-circle-check"
  }), _vm._v("上传完成")])], 2), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("立即生成岗位")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogAnalysis),
      expression: "dialogAnalysis"
    }],
    staticClass: "analysis-box"
  }, [_c('el-progress', {
    attrs: {
      "percentage": _vm.progress
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "analysis-text"
  }, [_vm._v(_vm._s(_vm.precentText))])], 1)], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-info flex"
  }, [_c('span', [_vm._v("1.上传招聘信息文件")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('span', [_vm._v("2.AI识别并批量生成岗位信息")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('span', [_vm._v("3.确认信息并保存")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc26c9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostBatchUpload.vue
// module id = 898
// module chunks = 1